import { memo } from "react"
import InlineSVG from "react-inlinesvg"

export const Svg = memo(InlineSVG)
